import { useToasts } from '../state/toasts'
import { Icon } from './Icon'

export function Toasts() {
  const toasts = useToasts((s) => s.toasts)
  const dismiss = useToasts((s) => s.dismiss)
  const hold = useToasts((s) => s.hold)
  const release = useToasts((s) => s.release)
  return (
    <div className="toast-region" role="status" aria-live="polite">
      {toasts.map((t) => (
        // A toast being read waits: the clock stops under a pointer and while anything in it has focus.
        <div
          className={t.error ? 'toast is-error' : 'toast'}
          key={t.id}
          onMouseEnter={() => hold(t.id)}
          onMouseLeave={() => release(t.id)}
          onFocus={() => hold(t.id)}
          onBlur={() => release(t.id)}
        >
          <span>{t.message}</span>
          {t.action ? (
            <button
              type="button"
              className="toast-action"
              onClick={() => {
                t.action?.onClick()
                dismiss(t.id)
              }}
            >
              {t.action.label}
            </button>
          ) : null}
          {t.duration === 0 || t.error ? (
            <button type="button" className="toast-close" aria-label="Dismiss" onClick={() => dismiss(t.id)}>
              <Icon name="x" />
            </button>
          ) : null}
        </div>
      ))}
    </div>
  )
}
